<template>
    <div>
        <v-card class="soft-shadow pa-1 mb-4">
            <v-card-title class="strong-text--text">
                <v-icon color="strong-text" class="me-1">mdi-file-plus-outline</v-icon>
                <span>تعديل السؤال #{{id}}</span>
            </v-card-title>
            <v-card-subtitle>قم بتعديل الحقول التي تريد تعديلها ثم الحفظ</v-card-subtitle>
            <v-card-text>
                <v-row>
                    <v-col cols="12" lg="7">
                        <v-form ref="form" class="my-3" @submit="submit">
                            <!-- <v-select v-model="questionType" label="نوع السؤال *" outlined :items="[{text: 'اختيار من متعدد', value: 'choices'}, {text: 'صواب وخطأ', value: 'truefalse'}]" :rules="[rules.global.required]" :disabled="loading"></v-select> -->
                            <v-textarea auto-grow rows="4" v-model="form.text" ref="textInput" label="نص السؤال *" outlined :rules="[rules.global.required]" :disabled="loading"></v-textarea>
                            <v-select v-model="form.difficulty_level" label="مستوى الصعوبة" outlined :items="[{text: 'عادي', value: 'normal'}, {text: 'سهل جداً', value: 'too_easy'}, {text: 'سهل', value: 'easy'}, {text: 'متوسط', value: 'medium'}, {text: 'صعب', value: 'difficult'}, {text: 'شديد الصعوبة', value: 'extreme'}]" :rules="[rules.global.required]" :disabled="loading"></v-select>
                            <v-textarea auto-grow rows="3" v-model="form.answer_explain_text" label="نص توضيح إجابة السؤال (اختياري)" outlined :disabled="loading"></v-textarea>

                            <v-btn color="primary" depressed block @click="submit" :loading="loading" :disabled="!formUpdated">
                                <v-icon left>mdi-file-check-outline</v-icon>
                                <span>حفظ التغييرات</span>
                            </v-btn>
                        </v-form>
                    </v-col>
                    <v-col cols="12" lg="5" class="ps-lg-10" style="max-width: 500px">
                        <div class="mb-10">
                            <div class="details-text mb-3 text-center">صورة السؤال</div>
                            <div v-if="questionData.image_url">
                                <v-img :src="questionData.image_url" contain height="200" max-width="500" class="bordered"></v-img>
                            </div>
                            <div v-else class="text-center mb-4">
                                <v-icon color="grey lighten-2" size="50">mdi-image</v-icon>
                            </div>
                            <div class="mt-2">
                                <v-btn color="primary" depressed block @click="changeImageDialog = true" outlined>
                                    <v-icon left>mdi-image-edit</v-icon>
                                    <span>{{questionData.image_url ? 'تغيير الصورة' : 'إضافة صورة'}}</span>
                                </v-btn>
                            </div>
                        </div>
                        <v-divider class="mb-5"></v-divider>
                        <div>
                            <div class="details-text mb-3 text-center">صورة توضيح إجابة السؤال</div>
                            <div v-if="questionData.answer_explain_image">
                                <v-img :src="questionData.answer_explain_image" contain height="200" max-width="500" class="bordered"></v-img>
                            </div>
                            <div v-else class="text-center mb-4">
                                <v-icon color="grey lighten-2" size="50">mdi-image</v-icon>
                            </div>
                            <div class="mt-2">
                                <v-btn color="primary" depressed block @click="changeAnwserExplainImageDialog = true" outlined>
                                    <v-icon left>mdi-image-edit</v-icon>
                                    <span>{{questionData.answer_explain_image ? 'تغيير الصورة' : 'إضافة صورة'}}</span>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>

                <v-divider class="my-4"></v-divider>

                <v-subheader class="text--text mb-3 px-0">اﻹجابات</v-subheader>
                <v-row>
                    <v-col v-for="answer in answersData" cols="12" lg="6" :key="answer.id" class="py-1">
                        <v-list-item :key="answer.id" class="mb-2 bordered">
                            <v-list-item-icon class="my-auto">
                                <v-menu bottom left :offset-y="true" transition="slide-y-transition">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @mousedown.stop @mouseover.stop @touchstart.stop @click.stop v-bind="attrs" v-on="on">
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense min-width="150" >
                                        <v-list-item dense @click="openEditAnswerDialog(answer)">
                                            <v-list-item-icon class="me-1">
                                                <v-icon color="muted" size="19">mdi-pencil</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="medium-text">تعديل</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <!-- <v-list-item dense>
                                            <v-list-item-icon class="me-1">
                                                <v-icon color="error" size="19">mdi-delete</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="medium-text">حذف</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item> -->
                                    </v-list>
                                </v-menu>
                            </v-list-item-icon>
                            <v-list-item-icon class="me-2 my-auto">
                                <v-icon v-if="answer.correct" color="success" size="22">mdi-check-circle-outline</v-icon>
                                <v-icon v-else color="muted" size="22">mdi-close-circle-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="strong-text--text">
                                <div class="d-flex pa-2" v-if="answer.image_url">
                                    <img :src="answer.image_url" style="max-height: 75px; max-width: 100%"/>
                                </div>
                                <div v-else>{{answer.text}}</div>
                            </v-list-item-title>
                        </v-list-item>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <div class="actions">
            <action-dialog v-model="editAnswerDialog" :as-form-data="true" action="post" :url="`/exams/questions/answers/${editedAnswerItem ? editedAnswerItem.id : ''}`" success-msg="تم حفظ التغييرات بنجاح" title="تعديل الإجابة" button-text="حفظ" :data="editedAnswerData" @reset="resetEditAnswerForm" @sync="syncAnswer">
                <v-form v-if="editedAnswerItem">
                    <v-select v-model="editedAnswerItem.type" hide-details outlined dense label="نوع اﻹجابة" :items="[{text: 'نص', value: 'text'}, {text: 'صورة', value: 'image'}]" class="mb-2" :disabled="editingAnswer"></v-select>
                    <v-file-input v-if="editedAnswerItem.type === 'image'" v-model="editedAnswerItem.image" hide-details accept="image/png, image/jpeg" outlined placeholder="اختر صورة" prepend-icon="" prepend-inner-icon="mdi-image" label="صورة السؤال" class="e-link" :rules="[rules.global.required]" :disabled="editingAnswer"></v-file-input>
                    <v-textarea v-else auto-grow hide-details rows="1" v-model="editedAnswerItem.text" :disabled="editingAnswer" label="نص اﻹجابة" outlined></v-textarea>
                    <v-checkbox v-model="editedAnswerItem.correct" label="إجابة صحيحة" color="green" hide-details class="mt-2"></v-checkbox>
                </v-form>
            </action-dialog>

            <action-dialog v-model="changeImageDialog" :as-form-data="true" action="post" :url="`/exams/questions/${id}/image`" success-msg="تم تغيير الصورة بنجاح" title="تغيير صورة السؤال" button-text="تأكيد" :data="{image: newImage}" @reset="newImage = null;" @sync="sync">
                <v-file-input v-model="newImage" ref="imageInput" accept="image/png, image/jpeg" outlined placeholder="اختر صورة" class="e-link" prepend-icon="" prepend-inner-icon="mdi-image" label="صورة السؤال" :disabled="loading" hide-details></v-file-input>
            </action-dialog>
            <action-dialog v-model="changeAnwserExplainImageDialog" :as-form-data="true" action="post" :url="`/exams/questions/${id}/answer-explain-image`" success-msg="تم تغيير الصورة بنجاح" title="تغيير صورة توضيح إجابة السؤال" button-text="تأكيد" :data="{image: newAnswerExplainImage}" @reset="newAnswerExplainImage = null;" @sync="sync">
                <v-file-input v-model="newAnswerExplainImage" accept="image/png, image/jpeg" outlined placeholder="اختر صورة" class="e-link" prepend-icon="" prepend-inner-icon="mdi-image" label="الصورة" :disabled="loading" hide-details></v-file-input>
            </action-dialog>
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    components: {
        
    },
    props: {
        question: {},
    },
    data() {
        return {
            loading: false,
            questionData: null,
            answersData: null,

            newImage: null,
            changeImageDialog: false,

            newAnswerExplainImage: null,
            changeAnwserExplainImageDialog: false,

            editAnswerDialog: false,
            editedAnswerItem: null,
            editingAnswer: false,

            form: {
                text: '',
                difficulty_level: 'normal',
                answer_explain_text: '',
            },
            questionType: 'choices',

            imageFile: null,

            rules: {
                global: {
                    required: value => !!value || 'لا يمكنك ترك الحقل فارغاً',
                    requiredArray: value => !!value.length || 'يجب تحديد اختيار واحد على اﻷقل',
                },
            }
        }
    },
    computed: {
        ...GlobalComputed,
        formUpdated(){
            for (const property in this.form){
                if (this.form[property] !== this.questionData[property]){
                    return true;
                }
            }
            return false;
        },
        id(){
            return this.questionData.id;
        },
        editedAnswerData(){
            let data = {};
            if (this.editedAnswerItem){
                if (this.editedAnswerItem.type === 'image'){
                    if (this.editedAnswerItem.image){
                        data.image = this.editedAnswerItem.image;
                    }
                }else if (this.editedAnswerItem.type === 'text'){
                    data.text = this.editedAnswerItem.text;
                }
                data.correct = this.editedAnswerItem.correct;
            }
            return data;
        }
    },
    watch: {
        /* form: {
            deep: true,
            handler(form){
                if (questionType === 'truefalse' && (this.answers.length !== 2 || this.answers[0].text !== 'صواب')){
                    this.answers = [
                        {type: 'text', text: 'صواب', image: null, correct: false,},
                        {type: 'text', text: 'خطأ', image: null, correct: false,},
                    ]
                }
            }
        } */
    },
    methods: {
        ...GlobalMethods,
        submit(){
            if (this.validate()){
                if (!this.loading){
                    this.loading = true;
                    const data = this.form;

                    this.$store.dispatch('fastPutAction', {url: '/exams/questions/' + this.id, data}).then(response=>{
                        this.loading = false;
                        const question = response.data.data;
                        this.sync(question);
                        Object.assign(this.form, {
                            text: question.text,
                            difficulty_level: question.difficulty_level,
                        });

                        this.showMsg('تم حفظ التغييرات بنجاح', 'success');

                    }).catch(e=>{
                        this.loading = false;
                        if (e.response && e.response.data && e.response.data.errors && Object.keys(e.response.data.errors).length){
                            const errors = e.response.data.errors;
                            let msg = errors[Object.keys(errors)[0]][0];
                            this.showMsg(msg, 'error');
                        }else{
                            const errorMsg = e && e.response.data ? e.response.data.message : null;
                            const msg = errorMsg || 'حدثت مشكلة أثناء تنفيذ طلبك';
                            this.showMsg(msg, 'error');
                        }
                    })
                }
            }
        },
        validate(){
            if (this.$refs.form.validate()){
                return true;
            }
            return false;
        },
        sync(data){
            Object.assign(this.questionData, data);
        },
        openEditAnswerDialog(answer){
            const type = answer.text ? 'text' : 'image';
            let answerObj = type === 'text' ? {id: answer.id, type, correct: answer.correct, text: answer.text} : {id: answer.id, type, correct: answer.correct, image: null};
            this.editedAnswerItem = Object.assign({}, answerObj);
            this.editAnswerDialog = true;
        },
        resetEditAnswerForm(){
            this.editedAnswerItem = null;
        },
        syncAnswer(newItem){
            this.answersData = this.answersData.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },

    },
    created(){
        this.questionData = this.question.data;
        this.answersData = this.questionData.answers;
        Object.assign(this.form, {
            text: this.questionData.text,
            difficulty_level: this.questionData.difficulty_level,
            answer_explain_text: this.questionData.answer_explain_text
        });

    },
    mounted(){

    }
}

</script>
